import { render, staticRenderFns } from "./DetailBookingPage.vue?vue&type=template&id=f62dad9c&"
import script from "./DetailBookingPage.vue?vue&type=script&lang=js&"
export * from "./DetailBookingPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailBookingPage.vue?vue&type=style&index=0&id=f62dad9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports